import React from "react";

const Facebook = props => (
  <svg viewBox="0 0 8.06 16.71" {...props}>
    <title>Facebook Icon</title>
    <g>
      <path
        d="M0 5.53h1.73V3.85a4.49 4.49 0 0 1 .56-2.59A3.07 3.07 0 0 1 5 0a10.86 10.86 0 0 1 3.1.31l-.47 2.56a5.83 5.83 0 0 0-1.39-.21c-.67 0-1.24.24-1.24.91v2h2.72L7.53 8H5v8.68H1.73V8H0z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default Facebook;



// WEBPACK FOOTER //
// ./src/icons/Facebook.js